import {
  SendReviewReminderRequest,
  SendReviewReminderSMSRequest,
} from "@/types/portalFunctionTypes";
import { axiosClient } from "../axiosClient";
import {
  CreateUserType,
  GetAllUsersResponse,
  PrivateUserInfo,
} from "@freetech/models/user";

export const admin = {
  getAllUsers: async (): Promise<GetAllUsersResponse> => {
    return await axiosClient.get("/portal/admin/users");
  },

  createFirebaseUser: async (
    userToCreate: CreateUserType
  ): Promise<{ userId: string }> => {
    return await axiosClient.post(
      "/portal/admin/users/create-user",
      userToCreate
    );
  },

  editFirebaseUser: async (
    userId: string,
    updateData: Partial<PrivateUserInfo>
  ): Promise<{ message: string; userId: string }> => {
    return await axiosClient.post("/portal/admin/users/edit-firebase-user", {
      userId,
      updateData,
    });
  },

  deleteFirebaseUser: async (userId: string) => {
    return await axiosClient.post("/portal/admin/users/delete-user", {
      userId,
    });
  },

  disableFirebaseUser: async (userId: string) => {
    return await axiosClient.post("/portal/admin/users/disable-user", {
      userId,
    });
  },

  enableFirebaseUser: async (userId: string) => {
    return await axiosClient.post("/portal/admin/users/enable-user", {
      userId,
    });
  },

  resendVerificationEmail: async (userId: string) => {
    return await axiosClient.post(
      "/portal/admin/users/resend-verification-email",
      { userId }
    );
  },

  sendInvoiceReminders: async (
    clientId: string,
    invoiceId: string,
    stakeholderIds: string[]
  ) => {
    return await axiosClient.post("/portal/admin/send-invoice-reminders", {
      clientId,
      invoiceId,
      stakeholderIds,
    });
  },

  sendAgreementReminders: async (
    freelancerIds: string[],
    agreementType: "Project Assignment" | "Independent Engineer Agreement",
    projectName?: string
  ) => {
    return await axiosClient.post("/portal/admin/send-agreement-reminders", {
      freelancerIds,
      agreementType,
      projectName,
    });
  },

  sendReviewReminder: async (
    reviewId: string,
    recipientEmail: string,
    recipientName?: string,
    sentBy?: string
  ) => {
    return await axiosClient.post("/portal/admin/send-review-reminder", {
      reviewId,
      recipientEmail,
      recipientName,
      sentBy,
    } as SendReviewReminderRequest);
  },

  sendReviewReminderSMS: async (
    reviewId: string,
    recipientPhone: string,
    recipientName?: string,
    sentBy?: string
  ) => {
    return await axiosClient.post("/portal/admin/send-review-reminder-sms", {
      reviewId,
      recipientPhone,
      recipientName,
      sentBy,
    } as SendReviewReminderSMSRequest);
  },
};
